import Container from "../layout/Container";
import ClassifiedShipping from "./ClassifiedShipping";

const AskSellerQuestion = () => {
  return (
    <Container>
      <div className="h-[356px] w-[551px] rounded border border-solid border-darkGreen border-opacity-30">
        <div className="py-4 px-5">
          <div>
            <div className="mb-8 flex w-full items-center justify-between">
              <p className="rounded-md bg-quantityColor py-3.5 px-14 font-pop text-2xl font-semibold text-primary">
                R 599,999
              </p>
              <div className="flex flex-col justify-center">
                <p className="rounded-md bg-quantityColor py-1 px-8 font-pop text-sm font-semibold text-secondary">
                  <span>0</span> Watching
                </p>
                <p className="mt-1 flex justify-center font-pop text-xs font-semibold text-darkGreen">
                  + Add to watchlist
                </p>
              </div>
            </div>
            <div className="w-full">
              <button className="rounded bg-primary py-3 px-[190px] font-pop text-xs font-bold text-white">
                Ask seller a question
              </button>
            </div>
          </div>
          <ClassifiedShipping />
        </div>
      </div>
    </Container>
  );
};

export default AskSellerQuestion;
